import { render, staticRenderFns } from "./integral_set.vue?vue&type=template&id=b3b36778&scoped=true"
import script from "./integral_set.vue?vue&type=script&lang=js"
export * from "./integral_set.vue?vue&type=script&lang=js"
import style0 from "./integral_set.vue?vue&type=style&index=0&id=b3b36778&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b36778",
  null
  
)

export default component.exports